module.exports = __webpack_public_path__ + "static/integrate-7b39a797d165c0cbd7c1db1ec1963c3d.png";